import React from 'react';
import { WidgetBox } from '../components';

const NotFound = ({ title }) => {
  return (
    <WidgetBox title="Widget missing" type="warning">
      <p className="bold">Could not find widget {title && <span><b>{title}</b></span>}</p>
    </WidgetBox>
  );
};

export default NotFound;


// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/cornerstone-widget-block/widgets/not-found.js